import { render, staticRenderFns } from "./BuilderAnnotation.vue?vue&type=template&id=016da802&scoped=true&"
import script from "./BuilderAnnotation.vue?vue&type=script&lang=js&"
export * from "./BuilderAnnotation.vue?vue&type=script&lang=js&"
import style0 from "./BuilderAnnotation.vue?vue&type=style&index=0&id=016da802&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016da802",
  null
  
)

export default component.exports